import React, { useState } from 'react';
import { MultiStep } from 'components/MultiStep';
import { generateContext } from 'utils/context';
import { Services } from 'services';
import { BoxLoader } from 'components/loaders';
import { Box } from '@clariness/clarikit-react';
import {
  PatientDetailsScreener,
  PatientDetailsFooter,
  PatientDetailsNotes,
  PatientDetailsProfile,
  PatientDetailsTabMenu,
  PatientDetailsActivity,
} from './components';
import { PatientDetailsContext, PatientDetailsModalProps } from './types';
import { useReferralSource } from './useReferralSource';

export const [usePatientDetailsContext, PatientDetailsProvider] =
  generateContext<PatientDetailsContext>();

export const ReferralDetails: React.FC<PatientDetailsModalProps> = () => {
  const { id: referralId, isExternalReferral } = useReferralSource();
  const [isEditingNotes, setIsEditingNotes] = useState(false);

  const { referral, isLoading } = Services.Referrals.useGetReferral(referralId);

  return (
    <PatientDetailsProvider
      value={{
        currentReferral: referral,
        isEditingNotes,
        isExternalReferral,
        setIsEditingNotes,
      }}
    >
      {isLoading ? (
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          paddingY="64px"
          paddingX="110px"
          style={{
            flex: 1,
            minHeight: 0,
            height: '100%',
            overflow: 'hidden',
            alignSelf: 'stretch',
          }}
        >
          <BoxLoader />
        </Box>
      ) : (
        <MultiStep>
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            style={{
              flex: 1,
              minHeight: 0,
              height: '100%',
              overflow: 'hidden',
              alignSelf: 'stretch',
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              width="100%"
              paddingY="64px"
              paddingX="110px"
              style={{ flex: 1, minHeight: 0, overflow: 'auto' }}
            >
              <PatientDetailsTabMenu
                patientName={`${referral?.patient?.firstName ?? ''} ${referral?.patient?.lastName ?? ''}`}
                patientID={referral?.patient?.internalId}
                siteID={referral?.site?.id}
                studyID={referral?.study?.id}
                isExternalReferral={isExternalReferral}
              />
              <MultiStep.Step>
                <PatientDetailsProfile />
              </MultiStep.Step>

              {isExternalReferral ? null : (
                <MultiStep.Step>
                  <PatientDetailsScreener referralId={referral?.id} />
                </MultiStep.Step>
              )}

              <MultiStep.Step>
                <Box>
                  <Box
                    style={{
                      height: '48vh',
                      overflow: 'scroll',
                      marginBottom: '5px',
                    }}
                  >
                    <PatientDetailsActivity />
                  </Box>
                  <PatientDetailsNotes />
                </Box>
              </MultiStep.Step>
            </Box>
            <PatientDetailsFooter />
          </Box>
        </MultiStep>
      )}
    </PatientDetailsProvider>
  );
};
